
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { getContactPhoneNumber } from "@/app/utils/EnvConfig";

@Component
export default class LoginPhone extends Vue {

    private get content(): string {
        return this.$localize("login.phone.message", getContactPhoneNumber());
    }
}
